import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';

import DefaultImage from '../../assets/default.jpg';
import { imageWithParams } from '../../utils/imageWithParams';

const Image = ({
  image_url,
  params,
  alt,
  height = 200,
  width = 200,
  className,
  onClick,
  fallbackImage,
  loading = 'lazy',
  decoding = 'async'
}) => {
  const [imageUrl, setImageUrl] = useState(() =>
    image_url ? imageWithParams({ image: image_url, params, height, width }) : (fallbackImage || DefaultImage)
  );
  const errorCount = useRef(0);

  useEffect(() => {
    if (image_url) {
      errorCount.current = 0;
      setImageUrl(imageWithParams({ image: image_url, params, height, width }));
    } else {
      setImageUrl(fallbackImage || DefaultImage);
    }
  }, [image_url, height, width, params, fallbackImage]);

  const onError = () => {
    errorCount.current += 1;
    if (errorCount.current === 1) {
      const cdnUrl = imageWithParams({ image: image_url, params, height, width });
      if (image_url && image_url !== cdnUrl) {
        setImageUrl(image_url);
      } else {
        setImageUrl(fallbackImage || DefaultImage);
      }
    } else {
      setImageUrl(fallbackImage || DefaultImage);
    }
  };

  return onClick ? (
    <img
      onClick={onClick}
      className={className}
      src={imageUrl}
      onError={onError}
      alt={alt}
      loading={loading}
      decoding={decoding}
    />
  ) : (
    <img
      className={className}
      src={imageUrl}
      onError={onError}
      alt={alt}
      loading={loading}
      decoding={decoding}
    />
  );
};

Image.propTypes = {
  image_url: PropTypes.string,
  params: PropTypes.shape(),
  alt: PropTypes.string,
  height: PropTypes.number,
  width: PropTypes.number,
  className: PropTypes.string,
  onClick: PropTypes.func,
  fallbackImage: PropTypes.any,
  loading: PropTypes.oneOf(['eager', 'lazy']),
  decoding: PropTypes.oneOf(['auto', 'async', 'sync'])
};

export default Image;
